import I18n from 'i18n-js';
import React, { Component } from 'react';
import classnames from 'classnames';
import { array, func, shape } from 'prop-types';
import MemberFromService from '../../members/components/MemberFromService';
import { chunk } from '../../common/utils/format';
import Masonry from 'react-masonry-component';

class ServiceSearchResults extends Component {
  static propTypes = {
    selectedService: shape().isRequired,
    servicesList: array.isRequired,
    fallbackService: func.isRequired,
  };

  /**
   * @param {Object} event
   * @param {Object} service
   */
  onClickService(event, service) {
    event.preventDefault();

    this.props.fallbackService(service);
  }

  /**
   * @param {Object} service
   *
   * @return {Element}
   */
  renderLinkService(service) {
    if (!service.suppliersCount) {
      return <span>{service.name} ({service.suppliersCount})</span>;
    }

    return <a href="" onClick={event => this.onClickService(event, service)}>{service.name} ({service.suppliersCount})</a>;
  }

  renderNoResult() {
    const { servicesList } = this.props;

    return (
      <div>
        <p className="no-result">
          <span className="no-result__title">{I18n.t('pages.services.no-result.title')}</span>
          <span>{I18n.t('pages.services.no-result.subtitle')}</span>
        </p>
        <div className="category-list">
          <h2 className="category-list__title">{I18n.t('pages.services.search-by-category')}</h2>
          <div className="row auto-clear">
            {chunk(servicesList, 4).map((column, index) => (
              <ul key={`col-${index}`} className="list-group col-xs-6 col-sm-4 col-lg-3">
                {column.map(service => {
                  const classes = classnames('list-group__item', {
                    'list-group__item--with-services': service.suppliersCount,
                  });

                  return (
                    <li className={classes} key={service.uuid}>
                      {this.renderLinkService(service)}
                    </li>
                  );
                })}
              </ul>
            ))}
          </div>
        </div>
      </div>
    );
  }

  /**
   * {@inheritdoc}
   */
  render() {
    const { selectedService } = this.props;
    
    if (selectedService.loading) {
      return <p>{I18n.t('common.loading')}</p>;
    }

    if (selectedService.error) {
      return <p>{I18n.t('common.error.listing')}</p>;
    }

    if (!selectedService.members.length && selectedService.service) {
      return this.renderNoResult();
    }

    return (
      <Masonry elementType="ul" className="list list--user" options={{ isFitWidth: true }}>
        {selectedService.members.map(member => <MemberFromService key={member.uuid} member={member} />)}
      </Masonry>
    );
  }
}

export default ServiceSearchResults;



// WEBPACK FOOTER //
// ./src/modules/services/components/ServiceSearchResults.js